import Modal from "./Modal";
import React, { useState } from "react";
import { ModalSize } from "../enums/ModalSize";
import Button from "../button/Button";
import { FormikValues, useFormikContext } from "formik";
import PasswordInput from "../input/PasswordInput";
import AlertBanner from "./AlertBanner";
import { loadIncompleteIntake } from "../../service/IncompleteIntakeService";
import TextInput from "../input/TextInput";
import { useApolloClient } from "@apollo/client";

export type LoadIncompleteIntakeModalProps = {
    formState?: string,
    onModalClose?: (e: Event) => void,
    children?: React.ReactNode
}

const LoadIncompleteIntakeModal = (props: LoadIncompleteIntakeModalProps) => {
    const [alert, setAlert] = useState(<></>)

    const formikContext = useFormikContext<FormikValues>();
    const apolloClient = useApolloClient()
    const values = formikContext.values;
    const setValues = formikContext.setValues;

    const formState = props.formState;

    if (!formState) {
        return null;
    }
    return <Modal id="load-incomplete-intake"
                  headerText="Finish your claim form"
                  onClose={props.onModalClose}
                  modalContent={
                      <div className="flex-gap">
                          <div>Welcome back! We saved your spot for you, we just need to verify your identity first.</div>
                          <div>
                              <TextInput id="incomplete-intake-email-address" required={false} inputProps={{ type: 'hidden' }}/>
                              <PasswordInput id="incomplete-intake-password" label="Passkey"/>
                          </div>
                          {alert}
                      </div>}
                  modalFooter={
                      <>
                          {'success' !== alert.props.variant
                              && <Button type="button" buttonContent="Continue claim form" onClick={async () => {
                                  try {
                                      setAlert(<></>)
                                      await loadIncompleteIntake(formState, values.incompleteIntakePassword, setValues, apolloClient.cache)
                                      setAlert(<AlertBanner variant="success"
                                                            message={<div>Claim form loaded successfully. You may close this dialog box and
                                                                continue with the form.</div>}
                                                            hideDismissButton={true}/>)
                                  } catch (e) {
                                      console.log(e)
                                      setAlert(<AlertBanner variant="error"
                                                            message={<div>Could not load claim. Please check your passkey and try again.</div>}
                                                            hideDismissButton={true}/>)
                                  }
                              }}/>}
                      </>}
                  modalSize={ModalSize.LARGE}
                  closeable={true}/>;
}

export default LoadIncompleteIntakeModal;
